import { DateTimeProvider } from '../components/DateTime'

function InitDateTimeProvider({ children, language, timeZone }) {
  return (
    <DateTimeProvider language={language} timeZone={timeZone}>
      {children}
    </DateTimeProvider>
  )
}

export default InitDateTimeProvider
